import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=61067bf7&scoped=true&"
import script from "./chart.vue?vue&type=script&lang=js&"
export * from "./chart.vue?vue&type=script&lang=js&"
import style0 from "./chart.vue?vue&type=style&index=0&id=61067bf7&lang=scss&scoped=true&"
import style1 from "./chart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61067bf7",
  null
  
)

export default component.exports